























































































import {Component, mixins} from "nuxt-property-decorator";
import LoginModal from "../components/modals/LoginModal.vue";
import RegistrationModal from "../components/modals/RegistrationModal.vue";
import RequestPasswordModal from "../components/modals/RequestPasswordModal.vue";
import SelectCityModal from "~/components/modals/SelectCityModal.vue";
import DialogLoading from "~/components/common/DialogLoading.vue";
import FastBuyProduct from "~/components/catalog/FastBuyProduct.vue";
import DialogAuthorizationMyAcuvue from "~/components/common/DialogAuthorizationMyAcuvue.vue";
import {
  AppMixin,
  CartMixin,
  CmsMixin,
  UserAuthMixin,
  UserMixin,
  WishlistMixin,
} from "~/node_modules/sitis-nuxt/lib/mixins";
import {BASE_API_URL} from '~/nuxt.config';
import BirthdayScreen from "~/components/birthday-screen/BirthdayScreen.vue";
//import DialogSendQuestNotification from "~/components/common/DialogSendQuestNotification.vue";
import OwlFakeWidget from "~/components/common/OwlFakeWidget.vue";

const PASS_REQUEST_TIMESTAMP = "PASS_REQUEST_TIMESTAMP";
const disabledPagesUnauthorizedUser = [
  'profile',
  'profile-bonuses',
  'profile-discount-card',
  'profile-zapis',
  'profile-my-acuvue'
];

@Component({
  head: function (this: LayoutDefault) {
    const meta: any = this.headerMetaAsync;
    const head = {
      meta: [...meta],
      titleTemplate: this.titleTemplate
    };

    return head
  },

  components: {
    BirthdayScreen,
    LoginModal,
    RegistrationModal,
    RequestPasswordModal,
    SelectCityModal,
    DialogLoading,
    DialogAuthorizationMyAcuvue,
    FastBuyProduct,
    OwlFakeWidget,

    PopUpAuthorizationRegistration: () => import("~/components/layouts/PopUpAuthorizationRegistration.vue"),
    PixelContent: () => import("~/components/layouts/PixelContent.vue"),
    DialogNotAvaibleNotification: () => import("~/components/common/DialogNotAvaibleNotification.vue"),
    DialogSendQuestNotification: () => import("~/components/common/DialogSendQuestNotification.vue"),
    DialogSwiper: () => import("~/components/common/DialogSwiper.vue"),
    PopupAgreementCookies: () => import("~/components/common/PopupAgreementsCookies.vue")
  },

  async fetch(this: LayoutDefault) {
    this.$device();
    this.checkBirthdayCookies();
    await this.getMenu();
  },

  computed: {
    wishlistCount: function () {
      return (this.$store.state?.wishlist?.items || []).length;
    }
  },

  watch: {

    '$route': function (this: LayoutDefault) {
      this.checkUserRoute();
    },

    itemsCount: async function (this: LayoutDefault) {
      if (!this.isAllInitDataForMinbox) {
        return
      }
    },
    wishlistCount: async function (this: LayoutDefault) {
      if (!this.isAllInitDataForMinbox) {
        return
      }
      await this.$store.dispatch("mindbox/productWishlistChange");
    },
  },
})
export default class LayoutDefault extends mixins(
  AppMixin,
  UserMixin,
  UserAuthMixin,
  CartMixin,
  CmsMixin,
  WishlistMixin
) {
  $device: any;
  $modal: any;
  $refs: any;
  $yandexMetrika: any;
  $customNotification: any;
  isHeadLogoVisible = false;
  modalOpen: boolean = false;
  showDialogLoading: boolean = false;
  showDialogAuthorizationMyAcuvue: boolean = false;
  isLoadCard: boolean = true;
  $cookies: any;
  $api: any;
  scTimer: any = 0;
  scY = 0;
  isShowCookiesPopup = false;

  isAllInitDataForMinbox: boolean = false;

  //переменные относящиесь к дню рождения
  showBirthdayScreen: boolean = true;
  isHasBirthdayScreenCookies: boolean = false;
  birthdayTimer: boolean = true;

  //------------------------------------------

  async mounted(): Promise<void> {
    await this.$store.dispatch("mindbox/initMindbox");

    this.setBirthdayTimer();

    await this.getCart();
    this.$store.commit('loadings/setCarts', false);

    await this.getUser({expanded: true});
    await this.getWishlist();
    await this.checkUserRoute();
    await this.getMyAcuvueProfile();
    await this.loadListShops();
    await this.sendAuthUserToYandexMetrika();
    await this.$store.dispatch("commerceOrders/checkLastOrders");
    await this.checkShowAgreementCookie();

    window.addEventListener('scroll', this.handleScroll);
    this.isAllInitDataForMinbox = true;
  }


  onSelectCity() {
    this.modalOpen = true;
    this.$nextTick(() => {
      this.$modal.show("select-city-modal");
    });
  }

  isHeaderLogoVisible(isVisible: boolean) {
    this.isHeadLogoVisible = isVisible;
  }

  onLogin(): void {
    const ts = localStorage.getItem(PASS_REQUEST_TIMESTAMP);
    if (ts) {
      const now = Date.now();
      this.$modal.show("login-modal", {
        canRequestAgain: Math.floor(Math.abs(now - Number(ts)) / 1000 / 60) > 1,
      });
    } else {
      this.$modal.show("request-password-modal");
    }
  }

  //методы для дня рождения------------------------------------------
  closeBirthdayScreen() {
    this.showBirthdayScreen = false;
  }

  setBirthdayTimer() {
    setTimeout(() => {
      this.birthdayTimer = false;
    }, 2000)
  }

  checkBirthdayCookies() {
    const showBirthdayCookies = this.$cookies.get('showBirthdayCookies');

    if (showBirthdayCookies === undefined || '') {
      this.$cookies.set('showBirthdayCookies', 'true', {
        path: '/',
        maxAge: 60 * 60 * 24,
        domain: '.linza.ru',
      })
      this.isHasBirthdayScreenCookies = true;
    }
  }

  get isEnableBirthdayScreen() {
    return this.vars['Включить заставку 30 лет'] === 'Да';
  }

  get isShowBirthdayScreen() {
    return this.showBirthdayScreen && this.isHasBirthdayScreenCookies && this.birthdayTimer && this.isEnableBirthdayScreen;
  }

  //-------------------------------------------------------------------------------------
  get headAdditionalMenu(): any[] {
    const headAdditionalMenu = this.getCmsMenu('header') || [];
    return headAdditionalMenu.items;
  }

  get footerMenu(): any[] {
    const footerMenu = this.getCmsMenu('footer') || [];
    return footerMenu.items as any[];
  }

  get bottomFooterMenu(): any[] {
    const bottomFooterMenu = this.getCmsMenu('footer2') || [];
    return bottomFooterMenu.items as any[];
  }

  get fastBuyProductId(): any {
    return this.$store.state['fast-buy'].productId || -1
  }

  get isOpenCustomNotification(): any {
    return this.$store.state['custom-notification'].isOpenCustomNotification || false;
  }

  get showDialogLoadingCustom(): any {
    return this.showDialogLoading || this.$store.state["local-settings"]?.showDialogLoading;
  }

  get isOpenSendQuestNotification(): any {
    return this.$store.state['send-quest-notification'].isOpenSendQuestNotification || false;
  }

  get isOpenSwiperPopup(): any {
    return this.$store.state['swiper-popup'].isOpenSwiperPopup || false;
  }

  get titleTemplate(): any {
    const {
      suffixDivider,
      suffixTitle
    } = this.$store.state?.appState?.config || {};

    let template = [suffixDivider, suffixTitle].filter((t) => !!t).join(" ");

    return `%s ${template}`
  }

  handleScroll(): void | null {
    if (this.scTimer) {
      return null
    }
    this.scTimer = setTimeout(() => {
      this.scY = window.scrollY;
      clearTimeout(this.scTimer);
      this.scTimer = 0;
    }, 100);
  }

  toTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  changeShowDialogLoading(showDialogLoading: boolean) {
    this.showDialogLoading = showDialogLoading;
  }

  checkUserRoute() {
    if (Object.keys(this.user || {}).length > 0) {
      return null
    }

    // Получаем текущие имя страницы
    const routeName = this.$route.name || '';

    // Проверяем, находится ли страница в заблокированных для неатворизованного пользователя
    if (disabledPagesUnauthorizedUser.includes(routeName)) {
      this.$router.replace('/authorization');
      // this.$nuxt.error({ statusCode: 401, message: 'Ошибка доступа' });
    }
  }

  openDialogAuthorization(options: any) {
    this.$refs.refHeader?.openAuthorization(options);
  }

  openDialogAuthorizationMyAcuvue() {
    this.showDialogAuthorizationMyAcuvue = true;
  }

  closeDialogAuthorizationMyAcuvue() {
    this.showDialogAuthorizationMyAcuvue = false;
  }

  sendAuthUserToYandexMetrika () {
    const userId = this.$store.state?.user?.user?.id || null;
    this.$yandexMetrika.setUserID(String(userId));
  }

  // Получение списка го
  async loadListShops() {
    const shopsList: any = await this.$api.agent.transport.get('/stores').then((res: any) => {
      return res.data
    }).catch(() => {
      return []
    });
    this.$store.commit("local-settings/setShopsList", shopsList);
  }

  async getCartLayout() {
    await this.getCart();
    this.$store.commit('loadings/setCarts', false);
  }

  async getMyAcuvueProfile() {
    const token = this.$cookies.get('authToken');

    if (!token || !process.env.myAcuvueIncluded) {

      this.$store.commit('myacuvue/setLoading', false);

      return null
    }

    // Получение пользовательского провиля MyAcuvue
    const {data: profile} = await this.$api.agent.transport.get("myacuvue/me").catch((err: any) => {
      return {data: {error: err.response}}
    });

    if (profile.error) {
      this.$store.commit('myacuvue/setLoading', false);

      return null
    }

    // Запись провиля в хранилище
    this.$store.commit('myacuvue/setProfile', profile);
    this.$store.commit('myacuvue/setLoading', false);
  }

  get isDemoStend() {
    return false
    return !Boolean(process.env.productionNodeEnv)
  }

  get addressApi() {
    return process.env.baseApiUrl
  }

  get countersHeader() {
    return this.appCfg?.counters?.header || ""
  }

  get countersFooter() {
    return this.appCfg?.counters?.footer || ""
  }

  get getCurrentHost() {
    return this.$store.getters['local-settings/currentHost'];
  }

  get headerMetaAsync() {
    const config = this.$store.state?.appState?.config;
    const headMeta = config?.head?.meta || [];

    let meta: any = [];

    headMeta.map((item: any) => {
      meta.push(
        {
          name: item.name,
          content: item.content
        },
      )
    });

    meta.push({
      hid: 'og:image',
      property: 'og:image',
      content: 'https://linza.ru/storage/0_logo-linza_fc99a32e.svg',
    },)

    meta.push({
      hid: 'og:image:alt',
      property: 'og:image:alt',
      content: 'Очки Для Вас',
    })

    meta.push({
      hid: 'og:url',
      property: 'og:url',
      content: `https://${this.getCurrentHost}${this.$route.fullPath}`,
    })

    return meta
  }
  // согласие с cookie
  checkShowAgreementCookie() {
    const agreementCookie = this.$cookies.get('cookies_accepted');
    if (agreementCookie === undefined || '') {
      this.isShowCookiesPopup = true;
    }
  }
  closePopupAgreementCookie () {
    this.isShowCookiesPopup = false;
  }
}
